/**
 * Follows the system colour scheme by toggling `.dark` on <html>. Staff web and
 * admin support dark theme from Phase 0. Returns a function that stops following.
 */
export function followSystemTheme(root: HTMLElement = document.documentElement): () => void {
	const query = window.matchMedia("(prefers-color-scheme: dark)");
	const apply = () => root.classList.toggle("dark", query.matches);
	apply();
	query.addEventListener("change", apply);
	return () => query.removeEventListener("change", apply);
}
